import React, {Component} from "react";
import ReactLoading from 'react-loading';

/*
* Authentication
*/
import Alt from 'alt';
import history from '../../../history';
import axios from 'axios';
import AuthActions from '../../../actions/AuthActions';
import AuthStore from '../../../stores/AuthStore';
import routes from '../../../routes';

import ExamList from '../../../components/ExamList';
import Ecg from '../../Ecg';
import Constants from '../../../components/Constants';

import ReactTooltip from 'react-tooltip'
import Pagination from "react-js-pagination";
import { Router, Route, Link } from 'react-router-dom'
import {
    Badge,
    Row,
    Col,
    Button,
    Label,
    Input,

    Nav,
    NavItem,
    NavLink
} from "reactstrap";
import classnames from "classnames";

class DashboardClient extends Component {

    getInitialState(){
        return {
            setState: undefined
        }
    }

    constructor(props) {
    super(props);

    this.refreshExamList = this.refreshExamList.bind(this);
    this.filterExamsClick = this.filterExamsClick.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);
    this.updateCheckboxValue = this.updateCheckboxValue.bind(this);
    this.resetFilterExamsClick = this.resetFilterExamsClick.bind(this);
    this.refreshReportedExamList = this.refreshReportedExamList.bind(this);

    this.state = {
        examList: null,
        reportedExamList: null,
        activePage: 1,

        loadingList: true,

        searchFilter: {
          firstResult: 0,
          maxResults: 10,

          reportStatus: "0",
          examRegister: "",
          clientName: "",
          patientName: "",
          beginExecutionDate: "",
          endExecutionDate: "",
          beginReceptionDate: "",
          endReceptionDate: "",
          beginReportDate: "",
          endReportDate: "",
          pediatricOnly: false,
          genericSearchText: "",
          lowPriorityOnly: false,
          excludeLowPriorityExams: false
        },

        reportedSearchFilter: {
          firstResult: 0,
          maxResults: 10,

          reportStatus: "1",
          examRegister: "",
          clientName: "",
          patientName: "",
          beginExecutionDate: "",
          endExecutionDate: "",
          beginReceptionDate: "",
          endReceptionDate: "",
          beginReportDate: "",
          endReportDate: "",
          pediatricOnly: false,
          genericSearchText: "",
          lowPriorityOnly: false,
          excludeLowPriorityExams: false
        }
      };


    }

    componentDidMount() {
      this.refreshExaListThread = setInterval(this.refreshExamList, 30000);
      this.refreshReportedExamListThread = setInterval(this.refreshReportedExamList, 30000);

      //Busca exames
      this.refreshExamList();
      this.refreshReportedExamList();
    }

    componentWillUnmount() {
      clearInterval(this.refreshExaListThread);
      clearInterval(this.refreshReportedExamListThread);
    }

    refreshReportedExamList() {
      axios({
        method: 'post',
        url: Constants.apiUrl+'/api/v1/exam/client/'+AuthStore.getState().user.entity_id,
        data: this.state.reportedSearchFilter
      })
      .then(response => {
          this.setState({
              reportedExamList: response.data
          });
      });
    }

    updateInputValue(evt, input) {
      let actualSearchFilter = this.state.searchFilter;
      actualSearchFilter[input] = evt.target.value;

      this.setState({
        searchFilter: actualSearchFilter
      });
    }

    updateCheckboxValue(evt, input) {
      let actualSearchFilter = this.state.searchFilter;
      actualSearchFilter[input] = !actualSearchFilter[input];

      this.setState({
        searchFilter: actualSearchFilter
      }, function(){
        this.refreshExamList();
      });
    }

    refreshExamList(){
      this.setState({
        loadingList: true
      });

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/client/'+AuthStore.getState().user.entity_id,
          data: this.state.searchFilter
      })
      .then(response => {
          this.setState({
              examList: response.data,
              loadingList: true
          });
      })
      .catch(error => {
        this.setState({
          loadingList: false
        })
      });
    }

    filterExamsClick(){
      this.refreshExamList();
    }

    resetFilterExamsClick(){
      this.setState({
        activePage: 1,

        searchFilter: {
          firstResult: 0,
          maxResults: 10,

          reportStatus: "0",
          examRegister: "",
          clientName: "",
          patientName: "",
          beginExecutionDate: "",
          endExecutionDate: "",
          beginReceptionDate: "",
          endReceptionDate: "",
          beginReportDate: "",
          endReportDate: "",
          pediatricOnly: false,
          reportSearchText: "",
          genericSearchText: "",
          lowPriorityOnly: false,
          excludeLowPriorityExams: false
        }
      }, () => this.refreshExamList());
    }

    handlePageChange(pageNumber) {

        this.setState({activePage: pageNumber});

        let filter = this.state.searchFilter;
        filter.firstResult = ((pageNumber-1) * 10);
        this.setState({
            searchFilter:  filter
        }, () => this.refreshExamList());
    }

    render() {
        if(this.state.examList == null) {
          if(this.state.loadingList) {
            return(
              <div style={{height:'100%'}}>
                <Row className="justify-content-center align-items-center" style={{height:'100%'}}>
                  {
                    <div className="text-center">
                      <ReactLoading type={'spinningBubbles'} color={'#20a8d8'} width={'100'} height={'100'}/>
                      <br/>
                      <b className="info-label">Carregando...</b>
                    </div>                  
                  }
                </Row>
              </div>
            );
          }

          return (
            <div style={{height:'100%'}}>
              <Row className="justify-content-center align-items-center" style={{height:'100%'}}>
                <div className="text-center">
                  <b className="info-label">Ocorreu um erro ao carregar os exames. <br/><br/> Verifique sua conexão ou entre em contato com o suporte.</b>
                </div>
              </Row>
            </div>
          );
        }

        return (
            <div>
              <Row>
                  <Col xs="12" md="5">
                      <Input type="text" id="genericSearchText" value={this.state.searchFilter.genericSearchText}
                        onChange={evt => this.updateInputValue(evt, "genericSearchText")} onKeyPress={event => {
                          if (event.key === 'Enter') {
                            this.filterExamsClick()
                          }
                        }} placeholder="Busca Genérica"/>
                  </Col>

                  <Col xs="6" md="2">
                      <Label htmlFor="excludeLowPriorityExams"></Label>
                      <Input type="checkbox" id="excludeLowPriorityExams" value={!this.state.searchFilter.excludeLowPriorityExams}
                        checked={!this.state.searchFilter.excludeLowPriorityExams}
                        onChange={evt => this.updateCheckboxValue(evt, "excludeLowPriorityExams")}/> Exibir fila de baixa prioridade
                        {'\u00A0'}
                        {
                          this.state.examList != null && this.state.examList.lowPriorityResults > 0 ?
                          <Badge color="info" pill>{this.state.examList != null ? this.state.examList.lowPriorityResults : 0}</Badge>
                          :
                          ''
                        }
                  </Col>

                  <Col xs="6" md="2">
                      <Label htmlFor="pediatricOnly"></Label>
                      <Input type="checkbox" id="pediatricOnly" value={this.state.searchFilter.pediatricOnly}
                        checked={this.state.searchFilter.pediatricOnly}
                        onChange={evt => this.updateCheckboxValue(evt, "pediatricOnly")}/> Somente Pediátricos
                  </Col>

                  <Col xs="4" md="3" className="text-right">
                      <Button color="primary" onClick={this.filterExamsClick.bind(this)} data-tip="Pesquisar">
                        <i className="fa fa-search"></i>{'\u00A0'}Pesquisar
                      </Button>
                      {'\u00A0'}
                      <Button color="warning" onClick={this.resetFilterExamsClick.bind(this)} data-tip="Limpar Filtros">
                        <i className="fa fa-times"></i>{'\u00A0'}Limpar Filtros
                      </Button>
                  </Col>
                </Row>
                <br />
                <br />
                <h6>Aguardando Laudo</h6>
                <ExamList examList={this.state.examList} hideReportLink={true}/>

                <br />
                <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={this.state.examList.totalResults}
                    pageRangeDisplayed={15}
                    onChange={this.handlePageChange.bind(this)}
                />

                <br />
                <br />
                <h6>Últimos exames analisados</h6>
                <ExamList examList={this.state.reportedExamList} showDtReport={true} hideReportLink={true} />
                <br />
                <Link to="/examSearchClient">
                    <Button color="default">Ver Mais</Button>
                </Link>
                <br /><br /><br />
                <ReactTooltip />

            </div>
        )
    }
}

export default DashboardClient;



// WEBPACK FOOTER //
// ./src/views/Dashboard/client/DashboardClient.js